import {doSuccessFailureActions} from '../_utils/actions.js';

export const FETCH_USERS = doSuccessFailureActions('FETCH_USERS');
export const DELETE_USER = doSuccessFailureActions('DELETE_USER');
export const MODIFY_USER = doSuccessFailureActions('MODIFY_USER');
export const ADD_USER = doSuccessFailureActions('ADD_USER');

// FETCH

export function fetchUsers() {
  return {type: FETCH_USERS.do};
}

export function fetchUsersSuccess(items) {
  return {type: FETCH_USERS.success, items: items};
}

export function fetchUsersFailure(err) {
  return {type: FETCH_USERS.failure, err: err};
}


// DELETE

export function deleteUser(id) {
  return {type: DELETE_USER.do, id: id};
}

export function deleteUserSuccess(id) {
  return {type: DELETE_USER.success, id: id};
}

export function deleteUserFailure(id, err) {
  return {type: DELETE_USER.failure, id: id, err: err};
}


// MODIFY

export function modifyUser(payload) {
  return {type: MODIFY_USER.do, payload: payload}
}

export function modifyUserSuccess(payload) {
  return {type: MODIFY_USER.success, payload: payload}
}

export function modifyUserFailure(payload, err) {
  return {type: MODIFY_USER.failure, payload: payload, err: err}
}


// ADD

export function addUser(payload) {
  return {type: ADD_USER.do, payload: payload}
}

export function addUserSuccess(payload) {
  return {type: ADD_USER.success, payload: payload}
}

export function addUserFailure(payload, err) {
  return {type: ADD_USER.failure, payload: payload, err: err}
}



// WEBPACK FOOTER //
// ./src/redux/users/actions.js